import { useTranslation } from 'react-i18next';
import { SelectFile } from './Components/SelectFile';
import { translations } from 'locales/translations';
import React from 'react';
import { Body } from '../Typography';
import BasicTypography from '../Typography/BasicTypography';
import { Box } from '../basic/Wrappers/Box';
import { useSelector } from 'react-redux';
import { selectglobalSettings } from 'app/slice/selectors';
import { AllowedSettings } from 'utils/globalSettings';

export interface LargeFilesUpdateProps {
  maxFilesCount?: number;
  disableFileUpload?: boolean;
}
export function LargeFilesUpdate({
  maxFilesCount,
  disableFileUpload,
}: LargeFilesUpdateProps) {
  const { t } = useTranslation();
  const systemSettings = useSelector(selectglobalSettings);
  const AllowLargeFilesUpload = systemSettings.GetBooleanByKey(
    AllowedSettings.AllowLargeFilesUpload,
  );
  const fh = React.useMemo((): React.ReactNode => {
    let s = AllowLargeFilesUpload
      ? t(translations.MaxLargeFileSize)
      : t(translations.MaxUploadFileSize);
    s = s.replace('{0}', AllowLargeFilesUpload ? '2' : '20');
    return (
      <>
        <Body bold={true}>{t(translations.DragTheFilesOrBrowse)}</Body>
        <div style={{ textAlign: 'center' }}> {s} </div>
      </>
    );
  }, [AllowLargeFilesUpload, t]);
  return (
    <>
      <Box>
        <BasicTypography>{t(translations.Attachments)}</BasicTypography>
        <SelectFile
          name="SelectFile"
          multiline={true}
          fullWidth
          placeholder={t(translations.Template)}
          label={t(translations.Template)}
          disabled={false}
          accept={'.*'}
          filesPlaceholder={fh}
          maxFilesCount={maxFilesCount}
          maxSize={
            AllowLargeFilesUpload ? 2 * 1024 * 1024 * 1024 : 20 * 1024 * 1024
          }
          disableFileUpload={disableFileUpload}
        />
      </Box>
    </>
  );
}
